import {
  TARGET_BUILDERS,
  type TargetBuilder,
} from "@/features/blueprints/blueprintTypes";

type BuilderSelectorProps = {
  value: TargetBuilder;
  disabled?: boolean;
  onChange: (value: TargetBuilder) => void;
};

export function BuilderSelector({
  value,
  disabled = false,
  onChange,
}: BuilderSelectorProps) {
  return (
    <div>
      <label
        htmlFor="target-builder"
        className="block text-sm font-medium text-slate-700"
      >
        Target builder
      </label>
      <select
        id="target-builder"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value as TargetBuilder)}
        className="mt-2 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-950 outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:bg-slate-100"
      >
        {TARGET_BUILDERS.map((builder) => (
          <option key={builder.value} value={builder.value}>
            {builder.label}
          </option>
        ))}
      </select>
      <p className="mt-2 text-xs leading-5 text-slate-500">
        Build Prompt remains platform-neutral unless a specific builder is
        selected.
      </p>
    </div>
  );
}
